export const formatDateApi = (dateStr) => {
  if (dateStr !== '') return dateStr.replace(/\//g, '-');
  return null;
};
